module.exports = __webpack_public_path__ + "static/media/stofferingen-32.8a14cfa6.jpg";